import { Responsive } from '@cian/ui-kit/responsive';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Header } from '../../components/Header';
import { useEventBus } from '../../hooks/useEventBus';
import { IApplicationState } from '../../types/redux';
import { AuthenticationModalContainer } from '../AuthenticationModalContainer';
import { DropdownContainer } from '../DropdownContainer';
import { DropdownBackdropContainer } from '../DropdownContainer/DropdownBackdropContainer';
import { HamburgerContainer } from '../HamburgerContainer';
import { LogoContainer } from '../LogoContainer';
import { NavBarContainer } from '../NavBarContainer';
import { UserRelatedContainer } from '../UserRelatedContainer';

export const HeaderContainer: React.FC = () => {
  useEventBus();

  const noResize = useSelector((state: IApplicationState) => state.noResize);

  if (noResize) {
    return (
      <>
        <Header
          noResize
          content={
            <>
              <LogoContainer />
              <NavBarContainer />
              <UserRelatedContainer />
              <AuthenticationModalContainer />
            </>
          }
        >
          <DropdownContainer />
        </Header>
        <DropdownBackdropContainer />
      </>
    );
  }

  return (
    <>
      <Header
        content={
          <>
            <Responsive phone tablet>
              <HamburgerContainer />
            </Responsive>
            <LogoContainer />
            <Responsive desktop>
              <NavBarContainer />
            </Responsive>
            <UserRelatedContainer />
            <AuthenticationModalContainer />
          </>
        }
      >
        <DropdownContainer />
      </Header>
      <DropdownBackdropContainer />
    </>
  );
};
